module.exports = __webpack_public_path__ + "static/masks-mobile-9c2f32c046f4c2c4c7f50f1f3004e097.png";